/**
 * Placeholder shapes for the group surfaces: the directory / my-groups rows,
 * the my-groups tile carousel and the group detail header.
 */
import { Skeleton, SkeletonGroup, skeletonKeys } from '../../components/ui/Skeleton';
import './groups.css';

interface CountProps {
  count?: number;
}

export function GroupRowsSkeleton({ count = 5 }: CountProps) {
  return (
    <SkeletonGroup className="all-groups__list">
      {skeletonKeys(count).map(key => (
        <div className="group-row" key={key} aria-hidden>
          <Skeleton shape="circle" className="group-skeleton__image" />
          <div className="group-skeleton__meta">
            <Skeleton className="group-skeleton__line group-skeleton__line--name" />
            <Skeleton className="group-skeleton__line group-skeleton__line--members" />
          </div>
          <Skeleton shape="rect" className="group-skeleton__cta" />
        </div>
      ))}
    </SkeletonGroup>
  );
}

export function GroupTilesSkeleton({ count = 4 }: CountProps) {
  return (
    <SkeletonGroup className="my-groups__carousel group-skeleton__carousel">
      {skeletonKeys(count).map(key => (
        <div className="group-skeleton__tile" key={key} aria-hidden>
          <Skeleton shape="rect" className="group-skeleton__tile-image" />
          <Skeleton className="group-skeleton__line group-skeleton__line--tile" />
        </div>
      ))}
    </SkeletonGroup>
  );
}

export function GroupDetailsSkeleton() {
  return (
    <SkeletonGroup className="group-skeleton__details">
      <Skeleton shape="rect" className="group-skeleton__cover" />
      <Skeleton shape="circle" className="group-skeleton__avatar" />
      <Skeleton className="group-skeleton__line group-skeleton__line--title" />
      <Skeleton className="group-skeleton__line group-skeleton__line--subtitle" />
      <Skeleton shape="rect" className="group-skeleton__button" />
      <Skeleton shape="rect" className="group-skeleton__tabs" />
    </SkeletonGroup>
  );
}
